module.exports = __webpack_public_path__ + "static/img/gywm_gsxx.ced88971.png";